import { Component, OnInit, Input, HostListener, inject } from '@angular/core';
import { Product } from '../../../../dto';
import { BaseComponent } from '../../../../core';
import { BADGE_TYPE } from '../../../../shared';

import * as SelectProductStore from '../../../../store/select-product';
import { GaService, ProductService } from 'src/app/services';
import { Subscription, takeWhile } from 'rxjs';

@Component({
  selector: 'app-product-single-renew',
  templateUrl: './product-single-renew.component.html',
  styleUrls: ['./product-single-renew.component.scss'],
  standalone: false,
})
export class ProductSingleRenewComponent extends BaseComponent implements OnInit {
  @Input()
  product: Product;

  @Input()
  use;

  @Input()
  itemListName: string;

  @Input()
  hasBadge = true;

  @Input()
  numberTag?: string;

  @Input()
  wide = false;

  @Input()
  isRecommendProduct?: boolean;

  @Input()
  excludeBadges: string[] = [];

  @Input()
  bestSeller = false;

  BADGE_TYPE = BADGE_TYPE;

  isChecked;
  subscription: Subscription;

  private gaService = inject(GaService);
  private productService = inject(ProductService);

  ngOnInit() {
    this.productService.resetSubject$.pipe(takeWhile(() => this.isAlive)).subscribe(async (products) => {
      if (this.subscription) this.subscription.unsubscribe(); // 기존 중복 구독 방지, 기존 구독 해제
      if (products === undefined) {
        this.isChecked = false;
      } else {
        for (let i = 0; i < products.length; i++) {
          if (products[i].id === this.product.mapperSaleProducts[0].id) {
            this.isChecked = true;
            return;
          } else {
            this.isChecked = false;
          }
        }
      }
    });
    this.use = this.use === undefined ? true : this.use;
    if (this.product?.mapperSaleProducts.length === 1) {
      for (let i = 0; this.productService.selectProducts.length > i; i++) {
        this.isChecked = this.productService.selectProducts[i].id === this.product.mapperSaleProducts[0].id;
        if (this.isChecked) return;
      }
    } else {
      this.product?.mapperSaleProducts.forEach((MapperSaleProduct) => {
        this.productService.selectProducts.forEach((selectProduct) => {
          if (selectProduct.id === MapperSaleProduct.id) {
            this.isChecked = true;
            MapperSaleProduct.optionCheck = true;
          }
        });
      });
    }
  }
  onSelectProduct(product: Product) {
    if (this.product.productStatus === this.PRODUCT_STATUS.OUT_OF_STOCK) {
      return;
    }
    let mapperSaleProducts = product.mapperSaleProducts;
    if (mapperSaleProducts.length === 1) {
      mapperSaleProducts[0].optionCheck = this.isChecked;
      this.isChecked = this.productService.addToSelect(mapperSaleProducts[0], this.itemListName);
    } else {
      if (this.subscription) {
        this.subscription.unsubscribe(); // 기존 중복 구독 방지, 기존 구독 해제
      }
      this.subscription = this.productService.setSelectOption$.pipe(takeWhile(() => this.isAlive)).subscribe((e) => {
        this.isChecked = false;
        for (let i = 0; mapperSaleProducts.length > i; i++) {
          if (mapperSaleProducts[i].optionCheck) {
            this.isChecked = true;
            return;
          }
        }
      });

      this.store.dispatch(
        new SelectProductStore.SetProduct({
          product: this.product,
          selectType: SelectProductStore.SelectType.CART,
          itemListName: this.itemListName,
        })
      );
    }
  }

  addToCartModal() {
    this.store.dispatch(
      new SelectProductStore.SetProduct({
        product: this.product,
        selectType: SelectProductStore.SelectType.CART,
        itemListName: this.itemListName,
      })
    );
  }

  goToProductDetail() {
    const isDesktop = this.deviceDetector.isDesktop() ? true : false;
    this.gaService.goToProductDetail(this.itemListName, this.product, isDesktop);
  }

  @HostListener('window:scroll', []) onWindowScroll() {
    localStorage.setItem('PC-PageYOffset', window.pageYOffset.toString());
  }
}
